import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Carousel, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./headerPhase2";
import ErrorModal from "./organisms/ErrorModal";
import { resources } from "../resource";
import { formatErrorMessage } from "../utils/errorHandler";
import { logError } from "../utils/logger";
import noSlotImg from "./../assets/img/no-slot-icon.svg";
import submitIcon from "./../assets/img/submit-icon.png";
import homeIcon from "./../assets/img/home-icon.png";
import phoneIcon from "./../assets/img/phone-icon.svg";
import axios from "axios";

const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

const Submission = (props) => {
  const location = useLocation();
  const patientForm = useSelector((state) => state.patientForm);
  const clinicUrl = useSelector((state) => state.auth.clinicUrl);
  const multipleUploads = useSelector((state) => state.multipleUploadDocument);
  const [apiErrorMessage, setApiErrorMessage] = useState(false);
  const _resources = resources[props?.language];
  const sessionId = useSelector((store) => store.auth.sessionId);
  const doxyUrl = patientForm?.validationResponse?.doxyUrl;

  const amountDue = patientForm.validationResponse.amountDue;
  const visitType = patientForm.validationResponse.visitType;

  const uploadDocuments = async () => {
    try {
      const source = axios.CancelToken.source();
      const timeout = setTimeout(() => {
        source.cancel(
          `Request timed out after ${process.env.REACT_APP_API_TIMEOUT}ms`,
        );
      }, process.env.REACT_APP_API_TIMEOUT);

      const documents = multipleUploads.imageList.map((item) => ({
        ...item,
        companyId: location.state?.submitPatientRespone.companyId,
        patientId: location.state?.submitPatientRespone.patientId,
      }));

      const response = await axios.post(
        `${API_URL}PatientCheckIn/UploadDocument`,
        documents,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          cancelToken: source.token,
        },
      );

      clearTimeout(timeout);

      await logError({
        source: "submission.uploadDocuments",
        message: "Success UploadDocument API Call",
        exception: null,
        sessionID: sessionId,
      });

      return response.data;
    } catch (error) {
      const errorMessage = formatErrorMessage(error);
      await logError({
        source: "submission.uploadDocuments",
        message: "Error in upload document API Call",
        exception: errorMessage,
        sessionID: sessionId,
      });

      setApiErrorMessage(true);
    }
  };

  useEffect(() => {
    if (multipleUploads.imageList.length > 0) {
      uploadDocuments();
    }
  }, [uploadDocuments, multipleUploads.imageList.length]);

  const renderCarousel = () => (
    <Carousel>
      {[
        "clinic-pic-one",
        "clinic-pic-two",
        "clinic-pic-three",
        "clinic-pic-four",
      ].map((pic, index) => (
        <div key={index}>
          <div className={pic}></div>
        </div>
      ))}
    </Carousel>
  );

  const renderProceedMessage = () => {
    if (!patientForm?.validationResponse.doxyUrl && amountDue) {
      return _resources.Submission.YOU_ARE_ALL_SET; // Please stop by the front desk
    }
    else {
      return _resources.Submission.WE_WILL_BE_RIGHT_TO_YOU; // Thank you.  Your acknowledgement has been sent.  
    }
  };

  const renderHomeButton = () => {
    if (clinicUrl) {
      return (
        <span
          className="back-home cursor-pointer mt-3 d-flex align-items-center"
          onClick={() => {
            window.history.replaceState({}, "");
            window.location.replace(clinicUrl);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-log-out mr-2"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1={21} x2={9} y1={12} y2={12} />
          </svg>
          {_resources.Submission.LOGOUT}
        </span>
      );
    }

    return (
      <a className="back-home" href="https://coraphysicaltherapy.com">
        <img
          src={homeIcon}
          alt="Home Icon"
          onClick={() =>
            window.location.replace("https://coraphysicaltherapy.com")
          }
        />
        <p>{_resources.Submission.BACK_TO_HOME}</p>
      </a>
    );
  };

  return (
    <>
      <ErrorModal
        visible={apiErrorMessage}
        onClose={() => setApiErrorMessage(false)}
        errorMessage={_resources?.Checkin.ERROR}
      />
      <Header />
      <Helmet>
        <title>CORA Health | Appointment Submitted</title>
      </Helmet>
      <div className="checkin-page-carousel d-flex justify-content-between">
        {!location.state ? (
          <div className="col-lg-7 submit-container">
            <img src={noSlotImg} alt="Submit Icon" />
            <p className="information text-center">
              {_resources.Submission.ISSUE_IN_CLINIC}
              <br />
              {_resources.Submission.FOR_MORE_INFO}
              <br />
              <br />
              <img src={phoneIcon} alt="Near By" className="mx-2" />{" "}
              <strong>(866) 443-2672</strong>
            </p>
            {amountDue ? (
              <div className="proceed-container">
                <p className="proceed">
                  {_resources.Submission.PROCEED_TO_FRONT_DESK}
                </p>
              </div>
            ) : null}
          </div>
        ) : (
          <div className="col-lg-7 submit-container">
            <img src={submitIcon} alt="Submit Icon" />
            <p className="information">
              {_resources.Submission.INFO_HAS_BEEN_SUBMITTED}
            </p>
            <div className="proceed-container">

              {
                renderProceedMessage() != ""
                  ?
                  <p className={`proceed text-center ${doxyUrl && "mb-4"}`}>
                    {renderProceedMessage()}
                  </p>
                  :
                  null
              }
              {doxyUrl && (
                <a
                  className="verify-btn p-3 mt-3"
                  href={doxyUrl}
                  target="_blank"
                  style={{ color: "black", textDecoration: "none" }}
                >
                  {_resources.Submission.DOXYTEXT}
                </a>
              )}
            </div>
            {renderHomeButton()}
          </div>
        )}
        <div className="col-lg-5 p-0 carousel-column">{renderCarousel()}</div>
      </div>
    </>
  );
};

export default Submission;
